import get from 'lodash.get';

import { WALDOGRAM_PRINT_TYPE } from '../constants/web-gallery-waldogram-constants';

/**
 * Returns custom print price totals for usage on Waldograms.
 *
 * @param {Object} price - The price object as returned from checkoutPrice mutation.
 * @returns {Object}
 */
const getCustomPrintPriceFromTotalPrice = price => {
  if (!price) {
    return {};
  }

  return {
    price: get(price, 'custom_prints_total_price.value', 0),
    shipping: get(price, 'custom_prints_shipping_cost.value', 0),
    tax: get(price, 'total_tax.value', 0),
    total: get(price, 'total_price.value', 0),
  };
};

/**
 * Determines the Waldograms WALDOGRAM_PRINT_TYPE.
 *
 * @param {Object} waldogram - A CustomPrint with type of WALDOGRAM.
 * @returns {WALDOGRAM_PRINT_TYPE}
 */
const getWaldogramPrintType = waldogram => {
  if (!waldogram) {
    return undefined;
  }

  // If the custom print has an account address attached on it
  // it means it's supposed to be printed externally.
  // At all predictable use cases it should also come with
  // shipping_required, shipping_price, and shipping_enabled all TRUE
  // but that is something the Waldogram creation UI should take care of.
  if (waldogram.custom_print.account_address) {
    return WALDOGRAM_PRINT_TYPE.OFFSITE;
  }

  return WALDOGRAM_PRINT_TYPE.ONSITE;
};

/**
 * Determines whether an album has Waldograms enabled.
 *
 * @param {Object} album - The album.
 * @returns {boolean}
 */
const albumSupportsWaldograms = album => {
  if (!album) {
    return false;
  }

  // TODO: add support for custom_prints_meta.offsite_shipping_enabled
  // when we support external address shipping
  return get(album, 'custom_prints_meta.onsite_delivery_enabled');
};

export {
  getCustomPrintPriceFromTotalPrice,
  getWaldogramPrintType,
  albumSupportsWaldograms,
};
